angular.module("app").controller("ResetSkinSettingsPageController", [
    '$scope',
    'skinService',
    'errorHandler',
    'logger',
    function ($scope, skinService, errorHandler, logger) {
        function init () {
            $scope.resetOptions = {
                config: false,
                css: false,
                blocks: false,
                popups: false
            };
        }
        init();

        $scope.submitForm = function () {
            var requestData = fetchData();
            if (requestData.length) {
                skinService.retest({what: requestData}).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("Skin options has been successfully reset");
                            init();
                            $scope.reset_form.$setPristine();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            } else {
                logger.logError("Check option that should be reset")
            }
        };

        function fetchData () {
            var requestData = [];
            for (var prop in $scope.resetOptions) {
                if ($scope.resetOptions[prop]) {
                    requestData.push(prop);
                }
            }
            return requestData
        }
    }
]);